export const SHIPPING_MESSAGES = {
	OutOfStock: {
		text: 'Not Available to Ship',
		icon: 'sign-circled-cancel-filled',
		class: 'red'
	},
	LowStock: {
		text: 'Limited Stock to Ship',
		icon: 'sign-circled-check',
		class: 'yellow'
	},
	InStock: {
		text: 'Shipping Available',
		icon: 'sign-circled-check',
		class: 'green'
	}
};

export const PICKUP_MESSAGES = {
	OutOfStock: {
		text: 'Not Available to Pickup',
		icon: 'sign-circled-cancel-filled',
		class: 'red'
	},
	LowStock: {
		text: 'Limited Stock to Pickup',
		icon: 'sign-circled-check',
		class: 'yellow'
	},
	AvailableNearBy: {
		text: 'In Nearby Stores',
		icon: 'sign-circled-check',
		class: 'yellow'
	},
	InStock: {
		text: 'Free Pickup Available',
		icon: 'sign-circled-check',
		class: 'green'
	},
	ShipToStore: {
		text: 'Free Ship to Store',
		icon: 'sign-circled-check',
		class: 'green'
	}
};
